import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=6744832c&scoped=true"
import script from "./technology.vue?vue&type=script&lang=js"
export * from "./technology.vue?vue&type=script&lang=js"
import style0 from "./technology.vue?vue&type=style&index=0&id=6744832c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744832c",
  null
  
)

export default component.exports